import GOSHxFarewill from 'ui/common/header/components/Lockup/BrandingLogos/GOSH-x-Farewill'
import BatterseaXFarewill from 'ui/common/header/components/Lockup/BrandingLogos/Battersea-x-Farewill'
import BHFXFarewill from 'ui/common/header/components/Lockup/BrandingLogos/BHF-x-Farewill'
import MacmillanxFarewill from 'ui/common/header/components/Lockup/BrandingLogos/Macmillan-x-Farewill'
import MarieCuriexFarewill from 'ui/common/header/components/Lockup/BrandingLogos/Marie-Curie-x-Farewill'
import CancerResearchxFarewill from 'ui/common/header/components/Lockup/BrandingLogos/Cancer-Research-UK-x-Farewill'
export const BRANDING_LOGOS = {
  "Great Ormond Street Hospital Children's Charity": GOSHxFarewill,
  "Battersea Dogs' and Cats' Home": BatterseaXFarewill,
  'British Heart Foundation': BHFXFarewill,
  'Macmillan Cancer Support': MacmillanxFarewill,
  'Marie Curie': MarieCuriexFarewill,
  'Cancer Research UK': CancerResearchxFarewill,
}

export const DEFAULT_PADDING = '14px'
